/* eslint-disable */
import { useState } from "react";
import { apiFetch } from "./auth/apiClient";
import TurnstileWidget from "./captcha/TurnstileWidget";
import "./ContactForm.css";

export default function ContactForm() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [captchaToken, setCaptchaToken] = useState("");
  const [captchaResetKey, setCaptchaResetKey] = useState(0);

  const update = (patch) => setForm((f) => ({ ...f, ...patch }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    if (!form.name || !form.email || !form.message) {
      setError("Please fill in your name, email, and message.");
      return;
    }
    if (!captchaToken) {
      setError("Please complete the captcha before sending.");
      return;
    }
    setSubmitting(true);
    try {
      const res = await apiFetch("/api/contact", {
        method: "POST",
        body: {
          name: form.name,
          email: form.email,
          phone: form.phone || null,
          message: form.message,
          captcha_token: captchaToken,
        },
      });
      setSuccess(res.message || "Thanks! Your enquiry has been sent.");
      setForm({ name: "", email: "", phone: "", message: "" });
      setCaptchaToken("");
      setCaptchaResetKey((k) => k + 1);
    } catch (err) {
      setError(err.message);
      // Tokens are one-shot; refresh the widget on any failure so the
      // user can retry without reloading the page.
      setCaptchaToken("");
      setCaptchaResetKey((k) => k + 1);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form className="vsc-form" onSubmit={submit}>
      <div className="vsc-row">
        <label>
          <span>Name <em>*</em></span>
          <input
            type="text"
            required
            value={form.name}
            onChange={(e) => update({ name: e.target.value })}
            placeholder="Your full name"
          />
        </label>
        <label>
          <span>Email <em>*</em></span>
          <input
            type="email"
            required
            value={form.email}
            onChange={(e) => update({ email: e.target.value })}
            placeholder="you@example.com"
          />
        </label>
      </div>
      <label>
        <span>Phone (optional)</span>
        <input
          type="tel"
          value={form.phone}
          onChange={(e) => update({ phone: e.target.value })}
          placeholder="+91 9876543210"
        />
      </label>
      <label>
        <span>Message <em>*</em></span>
        <textarea
          required
          rows={5}
          value={form.message}
          onChange={(e) => update({ message: e.target.value })}
          placeholder="Tell us how we can help…"
        />
      </label>

      <TurnstileWidget
        onToken={setCaptchaToken}
        onError={() => setCaptchaToken("")}
        onExpire={() => setCaptchaToken("")}
        resetKey={captchaResetKey}
      />

      {error && <div className="vsc-msg vsc-msg-error">{error}</div>}
      {success && <div className="vsc-msg vsc-msg-ok">{success}</div>}

      <button
        type="submit"
        disabled={submitting || !captchaToken}
        className="vsc-submit"
      >
        {submitting ? "Sending…" : "Send Enquiry"}
      </button>
    </form>
  );
}
